import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import clsx from "clsx";

interface OnboardingStepProps {
  children: React.ReactNode;
  onClose: () => void;
  isOpen: boolean;
  content: string;
  position?: "top" | "bottom";
}

const OnboardingStep: React.FC<OnboardingStepProps> = ({
  children,
  position = "bottom",
  content,
  onClose,
  isOpen,
}) => {
  return (
    <div className="relative">
      <div className="z-0 relative">{children}</div>
      {isOpen && (
        <div
          className={clsx(
            "absolute w-fit h-fit bg-navy/90 z-50 p-2 rounded-8 flex items-center gap-2 shadow-md left-1/2 transform -translate-x-1/2 whitespace-nowrap",
            {
              "-top-10": position === "top",
              "-bottom-12": position === "bottom",
            }
          )}
        >
          <div
            className={clsx("absolute left-1/2 transform -translate-x-1/2", {
              "top-[100%]": position === "top",
              "bottom-[100%]": position === "bottom",
            })}
          >
            <div
              className={clsx(
                "w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent",
                {
                  "border-t-[10px] border-t-navy/90": position === "top",
                  "border-b-[10px] border-b-navy/90": position === "bottom",
                }
              )}
            ></div>
          </div>
          <span>{content}</span>
          <span className="cursor-pointer" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </span>
        </div>
      )}
    </div>
  );
};

export default OnboardingStep;
